import { render } from "./App.vue?vue&type=template&id=a4e44c62"
const script = {}

import "./App.vue?vue&type=style&index=0&id=a4e44c62&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__